import React, { useEffect } from "react";
import "./privacy-policy.css";

const Terms_Conditions = () => {
  // 🔴 ADDED: PAGE HAMESHA TOP SE OPEN HOGA
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant", // smooth chahiye to "smooth"
    });
  }, []);

  return (
    <div className="privacy-wrapper">
      <div className="privacy-card">
        <h2 className="privacy-title">General Terms &amp; Condition :</h2>

        <p>
          a. “Customer” means a prospective customer interested in online
          booking/purchase of UJALA Products via www.UJALA.in Website
        </p>

        <p>
          b. In the event that the Customer is booking/purchasing on behalf of
          another person, the necessary details of such other person is also
          required to be mentioned and the requisite details of such other
          person are required to be produced at the time of Product delivery
          either Authorized UJALA Dealership as per requirement by the
          Authorized UJALA Dealer.
        </p>

        <p>
          c. In the event that the Customer wants to make a booking/purchase of
          more than one UJALA Product, the booking/purchase process is required
          to be repeated. In other words, one UJALA Product can be
          booked/purchased per booking.
        </p>

        <p>
          d. The online booking/purchase facility is for the convenience of the
          customers.
        </p>

        <p>
          e. The details of the Customer as provided by the Customer shall be
          used by UJALA and it’s Authorized Dealers for all correspondences with
          the Customer.
        </p>

        <p>
          f. The Customer is requested to thoroughly read and understand updated
          specifications, features of UJALA Product(s) posted on the official
          www.UJALA.in websites before making their choice. The choice of
          variants of the UJALA Product(s) would be updated on the official
          www.UJALA.in Website from time to time and shall be subject to
          availability at the selected Authorized UJALA Dealership.
        </p>

        <p>
          g. The price of the vehicle shall be as applicable on the date of
          invoicing of the UJALA Product. The prices are subject to change and
          we are not responsible / legally bound to inform you in advance.
        </p>

        <p>
          h. All formalities with respect to purchase of UJALA Product(s),
          including but not limited to the registration process (if any) shall
          be performed at the respective Authorized UJALA Dealership.
        </p>

        <p>
          i. The sale and delivery of UJALA Products shall be subject to
          fulfilment of all applicable statutory obligations and submission of
          requisite supporting documents. The originals of these documents will
          need to be produced at the Authorized UJALA Dealership or at the time
          of Delivery. In the event of the Customers failure to ensure
          compliance of these requirements, the booking amount paid by the
          Customer is liable to be forfeited.
        </p>

        <p>
          j. All parties shall ensure the compliance of the applicable
          provisions of the Information Technology Act, 2000 and its allied
          rules as amended from time to time.
        </p>

        <p>
          k. The Terms of Use and the Privacy Policy provided on “www.UJALA.in”
          shall be deemed to be a part and parcel of these terms and conditions.
        </p>

        <p className="privacy-footer">
          l. We assume that you have read all terms and conditions before going
          ahead with online booking/purchase.
        </p>
      </div>
    </div>
  );
};

export default Terms_Conditions;
